import { Injectable } from '@angular/core';
import { pick } from '@sama/micro-dash';
import { map } from 'rxjs/operators';
import { Point2D } from '../../../team-apis/otterdam/answers/shape-typings';
import {
  RectangleExpandContractHelper,
  supportedExpandContractShapeTypes,
} from '../tools/rectangle/rectangle-expand-contract-helper';
import { AbstractTranslationService } from './abstract-translation-service';

@Injectable()
export class RectangleExpandContractService extends AbstractTranslationService {
  protected method = 'resize';

  override setUpKeyboardShortcuts() {
    // Matching the nudging used in 3D for smaller pixel precisions.
    const getDelta = () => (this.store.state().pixelSize > 0.01 ? 1 : 0.01);
    const offsets$ = this.createOffset$(
      {
        leftShortcutName: 'contractLeft',
        rightShortcutName: 'expandRight',
        downShortcutName: 'contractDown',
        upShortcutName: 'expandUp',
      },
      getDelta,
    ).pipe(map((delta) => ({ delta })));
    super.setUpKeyboardShortcuts(this.createTranslationHelper$(offsets$));
  }

  protected getTranslationHelper(offset: Point2D) {
    return new RectangleExpandContractHelper(
      // top border is lineIndex 0, right border is 1
      // offset is [x, y], so if there is a value on x (left-right translation)
      // we want to move the right border and if there is a value on y (up-down
      // translation) we want to move the top border
      offset[0] === 0 ? 0 : 1,
      this.injector,
    );
  }

  protected override canTranslate() {
    return super.canTranslate() && this.areAllSelectedShapesRectangles();
  }

  private areAllSelectedShapesRectangles() {
    const selectedShapes = Object.values(
      pick(
        this.store.state().shapes,
        ...Object.keys(this.store.state().selection),
      ),
    );
    return selectedShapes.every((shape) =>
      supportedExpandContractShapeTypes.includes(shape.type),
    );
  }
}
